<template>
  <b-container fluid>
    <b-breadcrumb
      v-if="pageStatus == '1'"
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{ $t("dashboard") }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-breadcrumb
      v-else
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType != '/tasks'"
        to="/manage-employee"
      >{{ $t("manageEmployee") }}</b-breadcrumb-item>
      <b-breadcrumb-item :to="$store.state.selectedTaskType">{{ $t("employeeProfile") }}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <AppLoader
      v-if="isLoadingForm"
      class="text-center"
      small
    />
    <div
      style="height:80vh;"
      class="m-0"
      v-else
    >
      <b-row v-if="showingIntro && taskStatus !=4 && form.isShowFormIntro">
        <b-col
          cols="8"
          offset="2"
        >
          <div class="align-middle my-5">
            <h3>{{form.formTitle ? form.formTitle[selectedLanguage || 'english'] : 'No Title'}}</h3>
            <div style="height:calc(100vh - 375px);overflow:auto;">
              <p v-html="sanitizeHtml(form.formIntroText ? form.formIntroText[selectedLanguage|| 'english'] : 'No Title')"></p>
            </div>

            <b-form-checkbox
              class="text-center my-3"
              v-model="userConsent"
            >{{$t('questionnaires.consent')}}</b-form-checkbox>
            <b-button
              variant="outline-danger"
              class="mr-2"
              @click="backAction()"
            >Back</b-button>
            <!--{{$t('questionnaires.backToDashboard')}}-->
            <b-button
              variant="outline-success"
              :disabled="!userConsent"
              class="mr-2"
              @click="onClickProceed()"
            >{{$t('questionnaires.proceed')}}</b-button>
          </div>
        </b-col>
      </b-row>

      <b-row v-else>
        <!-- Left hand side container when form is submitted -->
        <b-col cols="3">
          <b-card
            header-tag="header"
            class="text-left"
          >
            <template v-slot:header>
              <h6 class="mb-0">Overview</h6>
            </template>
            <b-card-text>
              <strong>Date Assigned:</strong>
              <br />
              {{dateFormat(taskAssignedDate)}}
            </b-card-text>
            <b-card-text>
              <strong>Date Completed:</strong>
              <br />
              {{dateFormat(taskCompletedDate)}}
            </b-card-text>
            <b-card-text v-if="taskStatus == 4">
              <strong>Download</strong>
              <br />
              <a
                href="#"
                @click="downloadPdf()"
              >
                <font-awesome-icon
                  icon="file-pdf"
                  class="text-danger"
                  size="2x"
                />
              </a>
            </b-card-text>
            <b-button
              hidden
              v-if="taskStatus == 4"
              variant="danger"
              @click="reOpenTask()"
            >Re-open</b-button>
          </b-card>
        </b-col>

        <b-col :cols="6">
          <div style="overflow: hidden;height: calc(100vh - 200px);">
            <b-row>
              <b-col class="text-center">
                <h3 class="mt-2">{{form.formTitle ? form.formTitle[selectedLanguage || 'english'] : 'No Title'}}</h3>
                <p>{{form.formDescription ? form.formDescription[selectedLanguage || 'english'] : 'No Description'}}</p>
              </b-col>
            </b-row>

            <div
              id="scrollspy"
              class="preview-scrollable-wrapper p-3"
            >
              <div
                v-if="form.formSection.length"
                id="element"
                style="background-color:#F4F4F4;"
              >
                <b-form v-if="!isLoading">
                  <SectionContainer
                    v-for="(sectionData, index) in form.formSection"
                    :id="'section_'+index"
                    :isDisabled="isDisabled"
                    :isPreview="true"
                    :selectedLanguage="selectedLanguage"
                    :sectionData="sectionData"
                    :inputType="sectionData.inputType"
                    :key="index"
                    :counter="index"
                  />
                </b-form>
              </div>
            </div>
          </div>
          <b-row class="mt-3">
            <b-col
              cols="6"
              class="text-left"
            >
              <a
                v-if="form.formSection.length"
                href="#"
                class="btn btn-warning"
                v-scroll-to="{
								el: '#scrollspy',
								container: '#scrollspy',
								duration: 300,
								easing: 'linear',
								
								force: true,
								
								x: false,
								y: true
							}"
              >
                <font-awesome-icon icon="angle-up" />
              </a>
            </b-col>
            <b-col>
              <!-- v-if="form.formSection.length && taskStatus !=4" -->

              <b-button-group class="float-right">
                <b-button
                  v-if="form.formSection.length && taskStatus !=4 && pageStatus != '2'"
                  variant="outline-primary"
                  @click="onSavePostData"
                  :disabled="isLoading || isLoadingLocal"
                >
                  <span v-if="isLoading || isLoadingLocal">
                    <b-spinner
                      small
                      type="grow"
                    ></b-spinner>
                    {{$t('savingProgressText')}}
                  </span>
                  <span v-else>{{$t('saveProgressText')}}</span>
                </b-button>

                <!-- :isPreview="false" -->
                <b-button
                  v-if="form.formSection.length && taskStatus !=4 && pageStatus != '2'"
                  variant="outline-success"
                  @click="onValidateSubmit"
                >{{$t('submitText')}}</b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- end of col-9 preview area righ sections list -->
        <b-col
          cols="3"
          class="mt-2"
          style="position:relative; overflow-y:auto; height:calc(100vh - 200px)"
        >
          <b-list-group v-b-scrollspy:scrollspy="50">
            <b-list-group-item
              :class="rightAlign ? 'text-right' : 'text-left'"
              v-for="(section,index) in form.formSection"
              :active="currentSectionIndex === index"
              @click="onScrollClick(index)"
              button
              :key="section.id"
            >
              <b-badge
                v-if="!rightAlign"
                variant="dark"
              >{{(index+1)}}</b-badge>
              &nbsp; {{ section.sectionTitle[selectedLanguage] }}
              <b-badge
                v-if="rightAlign && selectedLanguage == 'arabic'"
                variant="dark"
              >{{(new Intl.NumberFormat('ar-EG', { }).format(index+1))}}</b-badge>
              <b-badge
                v-if="rightAlign && selectedLanguage == 'hebrew'"
                variant="dark"
              >{{(index+1)}}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <!-- review modal -->
      <b-modal
        id="modal-1"
        modal-header-close="No"
        :ok-title="$t('submitText')"
        :cancel-title="$t('cancelBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('employees.submitModalTitle')"
        @ok="onSubmit"
      >
        <p>{{$t('employees.formSubmitingMessage')}}</p>
        <p></p>
      </b-modal>

      <b-modal
        id="modal-2"
        modal-header-close="No"
        ok-only
        :ok-title="$t('closeBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('questionnaires.formSubmittedModalTitle')"
        @ok="tasksPageRoute"
      >
        <p>{{$t('formSubmittedMessage')}}</p>
        <p></p>
      </b-modal>

      <b-alert
        v-model="showErrorToast"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000;"
        variant="danger"
        dismissible
        solid
      >{{$t('formValidationMessage')}}</b-alert>
    </div>
  </b-container>
</template>

<script>
/* eslint-disable */
import uid from "uid";
import { Helper } from "../../helpers";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SectionContainer from "../../containers/SectionUserContainer";
import AppLoader from "../../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import _ from "lodash";
import moment from "moment";
import "moment/locale/es";
import Cryptr from "cryptr";

export default {
  name: "EmployeeUserForm",
  components: {
    SectionContainer,
    AppLoader,
  },
  data () {
    return {
      isDisabled: 0,
      enabled: true,
      dragging: false,
      selected: "english",
      isInvalid: false,
      pageIntroText: "",
      showingIntro: true,
      showErrorToast: false,
      currentSectionIndex: 0,
      taskStatus: null,
      userConsent: 0,
      taskAssignedDate: null,
      taskCompletedDate: null,
      taskId: null,
      taskFiles: [],
      fromButton: false,
      isLoadingLocal: false,
      inValidElements: [],
      inValidSections: [],
      pageStatus: null,
      isLoadingForm: false,
    };
  },

  mounted () {
    this.$store.state.selectedTaskType = localStorage.getItem( 'selected_task_type' );
    this.clearLocalStorage();
    this.$store.state.employeeDashboardTabIndex = 0;
    this.taskId = this.$route.params.taskId;
    this.pageStatus = this.$route.params.readOnly;
    this.$store.state.validFields = true;
    this.getTaskForm();
  },

  beforeDestroy () { },

  beforeRouteLeave ( to, from, next ) {
    if ( this.$route.name == "emplyee-user-form" ) {
      if ( this.fromButton ) {
        next();
      } else {
        const answer = window.confirm( this.$t( "formLeaveAlertMessage" ) );
        if ( answer ) {
          this.$store.state.userFormSubmitArray = [];
          this.$store.state.getUserFormSubmitArray = [];
          this.onResetLocalData();
          next();
        } else {
          next( false );
        }
      }
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),

    ...mapState( {
      userFormSubmitArray: "userFormSubmitArray",
      form: "form1",
      validFields: "validFields",
      rightAlign: "rightAlign",
      progressValue: "progressValue",
      progressMaxValue: "progressMaxValue",
    } ),
  },

  watch: {
    selectedLanguage ( lang ) {
      this.updateTitles( lang );
    },
  },

  methods: {
    sanitizeHtml,
    ...mapActions( ["setLanguage"] ),
    ...mapMutations( ["TOGGLE_LOADER"] ),
    ...mapMutations( ["UPDATE_FORM"] ),

    dateFormat ( value ) {
      if(value) {
        moment.locale( "en" );
        return moment( value ).format( "LLLL" );
      }
      return '';
    },

    async reOpenTask () {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        await HTTP(
          "post",
          "api/v1/governance/training/employee/task/update",
          {
            task_id: this.$route.params.taskId,
            task_status: 1,
            form_type: "governance",
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        this.tasksPageRoute();
      } catch ( error ) {
        return [error];
      }
    },

    makeToast () {
      const h = this.$createElement;
      const vNodesMsg = h( "p", { class: ["text-center", "mb-0"] }, [
        h( "b-spinner", { props: { type: "grow", small: true } } ),
        this.$t( "toast.generatePDF" ),
        h( "b-spinner", { props: { type: "grow", small: true } } ),
      ] );
      this.$bvToast.toast( [vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000,
      } );
    },

    async downloadPdf () {
      let titleForm = this.form.formTitle ? this.form.formTitle[this.selectedLanguage || 'english'] : 'No Title';
      let fileName = `${titleForm}.pdf`
      // let formDefaultLanguage = localStorage.getItem( "formDefaultLanguage" );
      this.makeToast();
      try {
        let response = await HTTP(
          "get",
          "api/v1/onboarding/download/task/" + this.taskId,
          null,
          {
            Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
          },
          null,
          false,
          "blob"
        );
        if ( response ) {
          if ( window.navigator.msSaveOrOpenBlob ) {
            let blob = new Blob( [response.data] );
            // IE11
            window.navigator.msSaveOrOpenBlob( blob, fileName );
            Helper.makeToast(
              this.$bvToast,
              "success",
              this.$t( "toast.successPDF" )
            );
            return;
          } else {
            const url = window.URL.createObjectURL( new Blob( [response.data] ) );
            const link = document.createElement( "a" );
            link.href = url;
            link.setAttribute( "download", fileName ); //or any other extension
            document.body.appendChild( link );
            link.click();
            if ( response ) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                this.$t( "toast.successPDF" )
              );
            }
          }
        }

      } catch ( error ) {
        Helper.makeToast( this.$bvToast, "danger", this.$t( "toast.errorPDF" ) );
        return error;
      }
      /*
      axios( {
        url: config.API_URL + "api/v1/onboarding/download/task/" + this.taskId,
        method: "GET",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
      } )
        .then( ( response ) => {
          if ( window.navigator.msSaveOrOpenBlob ) {
            let blob = new Blob( [response.data] );
            // IE11
            window.navigator.msSaveOrOpenBlob( blob, titleForm );
            Helper.makeToast(
              this.$bvToast,
              "success",
              this.$t( "toast.successPDF" )
            );
            return;
          } else {
            const url = window.URL.createObjectURL( new Blob( [response.data] ) );
            const link = document.createElement( "a" );
            link.href = url;
            link.setAttribute( "download", titleForm ); //or any other extension
            document.body.appendChild( link );
            link.click();
            if ( response ) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                this.$t( "toast.successPDF" )
              );
            }
          }
        } )
        .catch( ( error ) => {
          Helper.makeToast( this.$bvToast, "danger", this.$t( "toast.errorPDF" ) );
          return error;
        } );
        */
    },

    onClickProceed () {
      this.showingIntro = false;
      this.setUserFormSchemaToStore();
    },

    backAction () {
      if ( this.pageStatus == '1' ) {
        this.$router.push( "/dashboard" );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },
    tasksPageRoute () {
      if ( this.pageStatus == '1' ) {
        this.$router.push( "/dashboard" );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },
    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
      localStorage.removeItem( "activeFormId" );
      localStorage.removeItem( "userConsent" );
      this.$store.state.registerData = {};
      this.$store.state.progressValue = 0;
      this.$store.state.progressMaxValue = 0;
    },

    initializeFormData () {
      this.$store.state.progressMaxValue = 0;
      if (
        this.$store.state.getUserFormSubmitArray &&
        this.$store.state.getUserFormSubmitArray.length
      ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        this.$store.state.progressMaxValue = this.$store.state.getUserFormSubmitArray.length;
        this.calculateProgressValue( this.$store.state.getUserFormSubmitArray );
      } else {
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep( this.form );
        tempForm.formSection.map( ( section ) => {
          section.formElements.map( ( element, elementIndex ) => {
            this.$store.state.progressMaxValue += 1;
            this.$store.state.userFormSubmitArray.push( {
              elements: [],
              sectionId: section.id,
              sectionIndex: section.index,
              elementIndex: elementIndex,
              elementId: element.id,
              elementInputType: element.inputType,
              elementTitle: element.label,
              elementTitleAbb: element.label,
              sectionTitle: section.abbreviationLabel || section.sectionTitle ||element.label,
              language: this.selectedLanguage,
              isMultiSelect: 0,
              selectedChart: element.selectedCharts || null,
              enableSelfReporting:
                ( element.configuration &&
                  parseInt( element.configuration.enableSelfReporting ) ) ||
                0,
            } );
          } );
        } );
      }
    },

    updateTitles ( lang ) {
      const dd = this.$store.state.userFormSubmitArray;
      dd.map( ( a ) => {
        return ( a.language = lang );
      } );
    },

    calculateProgressValue ( array ) {
      const registerData = _.clone( this.$store.state.registerData );
      for ( let i = 0; i < array.length; i++ ) {
        if ( array[i].elements.length > 0 && array[i].elements[0].postValue ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.length
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].length &&
          array[i].elements[0][0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.phone
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
      }
      this.$store.state.registerData = registerData;
      let numkeys = Object.keys( registerData ).length;
      this.$store.state.progressValue = numkeys;
    },

    changeLanguage () {
      let tt = this.selected.toLowerCase();
      this.setLanguage( tt );
      this.TOGGLE_LOADER( 100 );
    },

    setUserFormSchemaToStore () {
      let form = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
      // let taskdata = JSON.parse( localStorage.getItem( "taskFormData" ) );
      this.updateFormToStore( form );
    },

    updateFormToStore ( form ) {
      this.UPDATE_FORM( form );
    },

    onValidateSubmit () {
      this.inValidElements = [];
      this.inValidSections = [];
      this.showErrorToast = false;
      EventBus.$emit( "onSubmitEndUserForm", "form submit" );
      this.getInvalidFields();
      this.checkForInValidFields();
    },

    checkForInValidFields () {
      let isValid = false;
      outerLoop: for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for ( let x = 0; x < this.$store.state.form1.formSection[i].formElements.length; x++ ) {
          if ( this.$store.state.form1.formSection[i].formElements[x].isInValid ) {
            let inValidData = {
              elementId: this.$store.state.form1.formSection[i].formElements[x].id,
              sectionId: this.$store.state.form1.formSection[i].id,
            };
            EventBus.$emit( "OnInvalidFieldCatch", inValidData );
            this.showErrorToast = true;
            isValid = false;
            console.log( "inValidElements", this.inValidElements );
            break outerLoop;
          }
          isValid = true;
        }
      }
      if ( isValid ) {
        this.onReviewSubmit();
      }
    },

    getInvalidFields () {
      for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            this.inValidElements.push(
              this.$store.state.form1.formSection[i].formElements[x]
            );
          }
        }
      }
    },

    onReviewSubmit () {
      if ( this.$store.state.validFields ) {
        this.showErrorToast = false;
        this.$bvModal.show( "modal-1" );
      } else {
        this.showErrorToast = true;
      }
    },

    async onSubmit () {
      await this.saveFormData( 4 );
    },

    async saveFormData ( status ) {
      let taskData = this.$store.state.userFormSubmitArray;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        let result = await HTTP(
          "post",
          "api/v1/governance/training/employee/task/update",
          {
            task_status: 4,
            form_data: taskData,
            status: status,
            task_id: this.taskId,
            form_type: "governance",
            user_id: localStorage.getItem( "userId" ),
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        if ( result ) {
          this.fromButton = true;
          this.$bvModal.show( "modal-2" );
        }
      } catch {
        this.fromButton = true;
        this.$bvModal.show( "modal-2" );
      }
    },

    onScrollClick ( index ) {
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById( id ).scrollIntoView( { behavior: "smooth" } );
    },

    // auto save logic for user form--------
    async onSavePostData () {
      EventBus.$emit( "onSubmitEndUserForm", "progress" );
      this.isLoadingLocal = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let taskData = this.$store.state.userFormSubmitArray;
      try {
        await HTTP(
          "post",
          "api/v1/governance/training/employee/task/update",
          {
            task_status: 1,
            form_data: taskData,
            status: status,
            task_id: this.taskId,
            form_type: "governance",
            user_id: localStorage.getItem( "userId" ),
          },
          {
            Authorization: token,
          },
          null,
          false
        );
        this.isLoadingLocal = false;
        Helper.makeToast(
          this.$bvToast,
          "success",
          this.$t( "toast.saveSuccess" ),
          this.$t( "toast.title" )
        );
      } catch {
        this.isLoadingLocal = false;
        Helper.makeToast( this.$bvToast, "danger", this.$t( "toast.saveError" ) );
      }
    },
    clearLocalStorage () {
      this.$store.state.validFields = true;
      this.$store.state.form1 = {
        version: 1.0,
        formId: null,
        formStatus: 1, // 1=draft, 2=published, 3=expired
        formDefaultLanguage: "english",
        formVersion: null,
        formTitle: {
          english: "Form Title",
        },
        formDescription: {
          english: "Form Description",
        },
        formIntroText: {
          english: null,
        },
        formType: 1, // 1= Questionaire, 2= Survey, 3=Training, 4= Exam
        formTranslations: ["English"],
        formSection: [
          {
            type: "section",
            id: uid(),
            index: 0,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: "Section 1 Title",
            },
            formElements: [],
          },
        ],
        formJSCode: null,
        formCSS: null,
        formLayout: "vertical", // 'tabs',
        formPassword: null,
      };
      this.$store.state.getUserFormSubmitArray = [];
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "activeTaskStatus" );
    },
    async getTaskForm () {
      this.isLoadingForm = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: this.taskId,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if ( result.data.task ) {
        let form = result.data.task.schema;
        this.form = form;
        let form_data = JSON.parse( result.data.task.form_data );
        this.$store.state.getUserFormSubmitArray = [];
        if ( form_data && form_data.user_data.length ) {
          form_data.user_data.map( data => {
            this.$store.state.getUserFormSubmitArray.push( data );
          } );
        }
        this.taskAssignedDate = result.data.task.created_at;
        if(result.data.task.task_status == 4) {
            this.taskCompletedDate = result.data.task.updated_at;
        }
        localStorage.setItem( "activeFormSchema", form );
        localStorage.setItem( "activeTaskStatus", result.data.task.task_status );
        if(result.data.task.is_active) {
          const cryptr = new Cryptr("myTotalySecretKey");
          const encryptedString = cryptr.encrypt(result.data.task.is_active);
          localStorage.setItem("formStatus", encryptedString);

        }
        this.setUserFormSchemaToStore();
        this.initializeFormData();
        let ff = JSON.parse( form );
        this.taskStatus = result.data.task.task_status;
        if ( this.taskStatus == 4 ) {
          this.isDisabled = this.taskStatus == 4 ? 1 : 0;
        } else {
          this.isDisabled = this.pageStatus == "2" ? 1 : 0;
        }
        if ( ff.isShowFormIntro ) {
          this.pageIntroText = ff.formIntroText[this.selectedLanguage];
        }
        this.isLoadingForm = false;
        if ( result.data.task.task_status != 4 ) {
          let userType = localStorage.getItem( "userType" );
          if ( userType == 1 || userType == 2 ) {
            return;
          } else {
            // this.updateTaskStatus( 1 );
          }
        }
      }
    },
    async updateTaskStatus ( status ) {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        await HTTP(
          "post",
          "api/v1/governance/training/employee/task/update",
          {
            task_id: this.$route.params.taskId,
            task_status: status,
            form_type: "governance",
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        this.taskStatus = status;
      } catch ( error ) {
        return [error];
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 240px);
  /* height:400px */
}
.selectPicket {
  width: 350px;
}
</style>

